//#region src/core/i18n/text/menu.ts
const prefix = "menu.";
const settingsText = {
	key: `${prefix}settings`,
	text: "Settings"
};
const qualityText = {
	key: `${prefix}quality`,
	text: "Quality"
};
const audioText = {
	key: `${prefix}audio`,
	text: "Audio"
};
const defaultText = {
	key: `${prefix}default`,
	text: "Default"
};
const speedText = {
	key: `${prefix}speed`,
	text: "Speed"
};
const captionsText = {
	key: `${prefix}captions`,
	text: "Captions"
};
const playbackRateText = {
	key: `${prefix}playbackRate`,
	text: "Playback rate"
};
const backText = {
	key: `${prefix}back`,
	text: "Back"
};
const offText = {
	key: `${prefix}off`,
	text: "Off"
};
const autoText = {
	key: `${prefix}auto`,
	text: "Auto"
};
const autoWithLabelText = {
	key: `${prefix}autoWithLabel`,
	text: "Auto ({label})"
};
const subtitlesText = {
	key: `${prefix}subtitles`,
	text: "Subtitles"
};
//#endregion
export { audioText, autoText, autoWithLabelText, backText, captionsText, defaultText, offText, playbackRateText, qualityText, settingsText, speedText, subtitlesText };

//# sourceMappingURL=menu.js.map